module.exports = __webpack_public_path__ + "static/before3-8cd4d06c37b0795da8a023c2c036cbe6.jpg";